import SimpleFutureTenseWorksheet from "../../components/ClassOne/English/SimpleFutureTense";
import SimplePastTenseWorksheet from "../../components/ClassOne/English/SimplePastTense";
import SimplePresentTenseWorksheet from "../../components/ClassOne/English/SimplePresentTense";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/simple-tenses/simple-present-tense", title: "Simple Present Tense", component: SimplePresentTenseWorksheet },
    { url: "/class-one/english/simple-tenses/simple-past-tense", title: "Simple Past Tense", component: SimplePastTenseWorksheet },
    { url: "/class-one/english/simple-tenses/simple-future-tense", title: "Simple Future Tense", component: SimpleFutureTenseWorksheet },
];


export default topics;